
import './App.css';
import Bmi from './Bmi';

function App() {
  return (
    <div className="App">
      
        <Bmi></Bmi>

      </div>
    
  );
}

export default App;
